// angular import
import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import moment from 'moment';
import { RequestService } from 'src/app/services/http-service.service';

import { menus } from 'src/app/demo/data/hotelMenu';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // public props
  isSpinnerVisible = true;

  // constructor
  constructor(private router: Router, public request: RequestService) {
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.isSpinnerVisible = true;
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.isSpinnerVisible = false;
        }
      },
      () => {
        this.isSpinnerVisible = false;
      }
    );




    if (window.location.href.indexOf('iframe') == -1 && !/\/check/.test(window.location.href)) {
      moment.locale('de')

      if (!localStorage.getItem('hotel_token')) {
        this.router.navigate(['/login']);
      } else {

        let user = JSON.parse(localStorage.getItem('hotel_user'));
        this.request.get('administrators/' + user._id).then(res => {
          console.log('res', res);
          if (res?._id) {
            localStorage.setItem('hotel_user', JSON.stringify(res));
          } else {
            localStorage.clear();
            this.router.navigate(['hotel', 'login']);
          }
        })

      }

      //this.router.navigateByUrl('/hotel');
    }
    //this.loop();

  }

  loop() {

    if (localStorage.getItem('objectId')) {

      this.request.get("requests/objs/" + localStorage.getItem('objectId')).then(async (res) => {

        let badge = 0;

        for await (let item of res) {
          item.fullName = item.name + ' ' + item.surname;

          if (item.status == '0') {
            badge++;
          }
        }

        menus[4].badge.title = String(badge);
      });
    }

    setTimeout(() => {
      this.loop();
    }, 5000);
  }
}
